import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconButtonRoot } from "./icon-button.styles.js";
const IconButton = forwardRef(function IconButton2(inProps, ref) {
  const { eventId, color = "tertiary", variant = "text", ...props } = inProps;
  return /* @__PURE__ */ jsx(
    IconButtonRoot,
    {
      ownerState: {
        ...props,
        color,
        variant
      },
      ...props,
      ref,
      "data-eventid": eventId
    }
  );
});
export {
  IconButton
};
//# sourceMappingURL=icon-button.component.js.map
